// Evergiving
import { PaymentFieldConfig } from "@evergiving/common/dist/es2015/form";

// Form components
import { Spinner } from "@/lib/components/Spinner";

// Hooks
import { SubmissionState } from "@/lib/hooks/useAfterAddressFieldCommon";

export const SubmissionInProgressOverlay = ({
  paymentFieldConfig,
  submissionState,
  onClose,
}: {
  paymentFieldConfig?: PaymentFieldConfig;
  submissionState: SubmissionState;
  onClose: () => void;
}) => {
  if (submissionState === SubmissionState.Unsubmitted) {
    return null;
  }

  return (
    <div className="overlay">
      <div className="submissionProgressContainer">
        {submissionState === SubmissionState.Submitting ? (
          <>
            {paymentFieldConfig ? (
              <div>{paymentFieldConfig.paymentProcessingText}</div>
            ) : null}
            <Spinner className="submissionProgressSpinner" />
          </>
        ) : (
          <>
            {paymentFieldConfig ? (
              <div>{paymentFieldConfig.paymentFailedText}</div>
            ) : null}
            <button type="button" className="inlineButton" onClick={onClose}>
              Close
            </button>
          </>
        )}
      </div>
    </div>
  );
};
